import { Box, Button, Typography } from "@material-ui/core";
import PhoneIcon from "@material-ui/icons/Phone";
import { useHistory } from "react-router-dom";
import DetailSection from "../../../components/DetailSection";

export function PhoneNumbersSlice({ partnerId }) {
  const history = useHistory();

  return (
    <DetailSection title="Provisioned Phone Numbers">
      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
        Phone numbers are managed in the BoomCRM Phone Numbers page.
      </Typography>
      <Box>
        <Button
          variant="contained"
          color="primary"
          startIcon={<PhoneIcon />}
          onClick={() => history.push(`/provisioned-phone-numbers?partner_id=${partnerId}`)}
        >
          Manage Phone Numbers
        </Button>
      </Box>
    </DetailSection>
  );
}
